module.exports = __webpack_public_path__ + "static/media/delivery-green.7a759619.svg";